export default __webpack_public_path__ + "static/LabelOnlyPadding-b26a1a2062e4c6250cc0c42456ee67e5.png";